import actionConstants from '../constants/';

const completeProfileState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: '',
  errorMessage: '',
};

const updateProfileState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: '',
  errorMessage: '',
};

const ifscState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: '',
  errorMessage: '',
};

const signzyAuthState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: '',
  errorMessage: '',
};

const signzyAuthValues = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: '',
  errorMessage: '',
};

const panVerifyState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: '',
  errorMessage: '',
};

const bankVerifyState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: '',
  errorMessage: '',
};

const uploadDocState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: '',
  errorMessage: '',
};

const getStateState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: '',
  errorMessage: '',
};

const getCityState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: '',
  errorMessage: '',
};

const kycSubmitState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: '',
  errorMessage: '',
};

const toggleEnvState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: '',
  errorMessage: '',
};

const kycReSubmitState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorCode: '',
  errorMessage: '',
};

const initialState = {
  completeProfileState: { ...completeProfileState },
  updateProfileState: { ...updateProfileState },
  ifscState: { ...ifscState },
  signzyAuthState: { ...signzyAuthState },
  signzyAuthValues: { ...signzyAuthValues },
  panVerifyState: { ...panVerifyState },
  uploadDocState: { ...uploadDocState },
  getStateState: { ...getStateState },
  getCityState: { ...getCityState },
  bankVerifyState: {...bankVerifyState},
  kycSubmitState: {...kycSubmitState},
  kycReSubmitState: {...kycReSubmitState},
  toggleEnvState: {...toggleEnvState}
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function completeProfileReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_MERCHANT_PROFILE_REQUEST:
      return {
        ...state,
        completeProfileState: {
          ...state.completeProfileState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorCode: '',
          errorMessage: '',
        },
      };
    case actionConstants.GET_MERCHANT_PROFILE_SUCCESS:
      return {
        ...state,
        completeProfileState: {
          ...state.completeProfileState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          errorCode: '',
          errorMessage: '',
        },
      };

    case actionConstants.GET_MERCHANT_PROFILE_FAILURE:
      return {
        ...state,
        completeProfileState: {
          ...state.completeProfileState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: action.payload,
          errorMessage: '',
        },
      };

    case actionConstants.UPDATE_MERCHANT_PROFILE_REQUEST:
      return {
        ...state,
        updateProfileState: {
          ...state.updateProfileState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorCode: '',
          errorMessage: '',
        },
      };
    case actionConstants.UPDATE_MERCHANT_PROFILE_SUCCESS:
      return {
        ...state,
        updateProfileState: {
          ...state.updateProfileState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          errorCode: '',
          errorMessage: '',
        },
      };
    case actionConstants.UPDATE_MERCHANT_PROFILE_UPDATE:
      return {
        ...state,
        updateProfileState: action.payload,
      };
    case actionConstants.UPDATE_MERCHANT_PROFILE_FAILURE:
      return {
        ...state,
        updateProfileState: {
          ...state.updateProfileState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: action.payload,
          errorMessage: '',
        },
      };

    case actionConstants.GET_IFSC_REQUEST:
      return {
        ...state,
        ifscState: {
          ...state.ifscState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorCode: '',
          errorMessage: '',
        },
      };
    case actionConstants.GET_IFSC_SUCCESS:
      return {
        ...state,
        ifscState: {
          ...state.ifscState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          errorCode: '',
          errorMessage: '',
        },
      };

    case actionConstants.GET_IFSC_FAILURE:
      return {
        ...state,
        ifscState: {
          ...state.ifscState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: action.payload,
          errorMessage: '',
        },
      };

    case actionConstants.GET_SIGNZY_REQUEST:
      return {
        ...state,
        signzyAuthState: {
          ...state.signzyAuthState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorCode: '',
          errorMessage: '',
        },
      };
    case actionConstants.GET_SIGNZY_SUCCESS:
      return {
        ...state,
        signzyAuthState: {
          ...state.signzyAuthState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          errorCode: '',
          errorMessage: '',
        },
      };

    case actionConstants.GET_SIGNZY_FAILURE:
      return {
        ...state,
        signzyAuthState: {
          ...state.signzyAuthState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: action.payload,
          errorMessage: '',
        },
      };

    case actionConstants.GET_PANTOGSTLIST_REQUEST:
      return {
        ...state,
        signzyAuthValues: {
          ...state.signzyAuthValues,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorCode: '',
          errorMessage: '',
        },
      };
    case actionConstants.GET_PANTOGSTLIST_SUCCESS:
      return {
        ...state,
        signzyAuthValues: {
          ...state.signzyAuthValues,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          errorCode: '',
          errorMessage: '',
        },
      };

    case actionConstants.GET_PANTOGSTLIST_FAILURE:
      return {
        ...state,
        signzyAuthValues: {
          ...state.signzyAuthValues,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: action.payload,
          errorMessage: '',
        },
      };

    case actionConstants.GET_PAN_VERIFY_REQUEST:
      return {
        ...state,
        panVerifyState: {
          ...state.panVerifyState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorCode: '',
          errorMessage: '',
        },
      };
    case actionConstants.GET_PAN_VERIFY_SUCCESS:
      return {
        ...state,
        panVerifyState: {
          ...state.panVerifyState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          errorCode: '',
          errorMessage: '',
        },
      };

    case actionConstants.GET_PAN_VERIFY_FAILURE:
      return {
        ...state,
        panVerifyState: {
          ...state.panVerifyState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: action.payload,
          errorMessage: '',
        },
      };

      case actionConstants.GET_BANK_VERIFY_REQUEST:
      return {
        ...state,
        bankVerifyState: {
          ...state.bankVerifyState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorCode: '',
          errorMessage: '',
        },
      };
    case actionConstants.GET_BANK_VERIFY_SUCCESS:
      return {
        ...state,
        bankVerifyState: {
          ...state.bankVerifyState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          errorCode: '',
          errorMessage: '',
        },
      };

    case actionConstants.GET_BANK_VERIFY_FAILURE:
      return {
        ...state,
        bankVerifyState: {
          ...state.bankVerifyState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: action.payload,
          errorMessage: '',
        },
      };

    case actionConstants.VERIFY_KYC_REQUEST:
      return {
        ...state,
        uploadDocState: {
          ...state.uploadDocState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorCode: '',
          errorMessage: '',
        },
      };
    case actionConstants.VERIFY_KYC_SUCCESS:
      return {
        ...state,
        uploadDocState: {
          ...state.uploadDocState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          errorCode: '',
          errorMessage: '',
        },
      };

    case actionConstants.VERIFY_KYC_FAILURE:
      return {
        ...state,
        uploadDocState: {
          ...state.uploadDocState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorCode: action.payload,
          errorMessage: '',
        },
      };

      case actionConstants.GET_STATE_REQUEST:
        return {
          ...state,
          getStateState: {
            ...state.getStateState,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            data: {},
            errorCode: '',
            errorMessage: '',
          },
        };
      case actionConstants.GET_STATE_SUCCESS:
        return {
          ...state,
          getStateState: {
            ...state.getStateState,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action.payload.body,
            errorCode: '',
            errorMessage: '',
          },
        };
  
      case actionConstants.GET_STATE_FAILURE:
        return {
          ...state,
          getStateState: {
            ...state.getStateState,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            data: {},
            errorCode: action.payload,
            errorMessage: '',
          },
        };

        case actionConstants.GET_CITY_REQUEST:
        return {
          ...state,
          getCityState: {
            ...state.getCityState,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            data: {},
            errorCode: '',
            errorMessage: '',
          },
        };
      case actionConstants.GET_CITY_SUCCESS:
        return {
          ...state,
          getCityState: {
            ...state.getCityState,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action.payload.body,
            target: action.payload.extra.target,
            errorCode: '',
            errorMessage: '',
          },
        };
  
      case actionConstants.GET_CITY_FAILURE:
        return {
          ...state,
          getCityState: {
            ...state.getCityState,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            data: {},
            target: action.payload.extra.target,
            errorCode: action.payload,
            errorMessage: '',
          },
        };
        case actionConstants.KYC_FORM_SUBMIT_REQUEST:
        return {
          ...state,
          kycSubmitState: {
            ...state.kycSubmitState,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            data: {},
            errorCode: '',
            errorMessage: '',
          },
        };
        case actionConstants.KYC_FORM_SUBMIT_CLEAR:
          return {
            ...state,
            kycSubmitState
          };
      case actionConstants.KYC_FORM_SUBMIT_SUCCESS:
        return {
          ...state,
          kycSubmitState: {
            ...state.kycSubmitState,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action.payload.body,
            errorCode: '',
            errorMessage: '',
          },
        };
  
      case actionConstants.KYC_FORM_SUBMIT_FAILURE:
        return {
          ...state,
          kycSubmitState: {
            ...state.kycSubmitState,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            data: {},
            errorCode: action.payload,
            errorMessage: action.payload.body,
          },
        };

        case actionConstants.KYC_FORM_RESUBMIT_REQUEST:
          return {
            ...state,
            kycReSubmitState: {
              ...state.kycReSubmitState,
              isLoading: true,
              isSuccess: false,
              isFailure: false,
              data: {},
              errorCode: '',
              errorMessage: '',
            },
          };
        case actionConstants.KYC_FORM_RESUBMIT_SUCCESS:
          return {
            ...state,
            kycReSubmitState: {
              ...state.kycReSubmitState,
              isLoading: false,
              isSuccess: true,
              isFailure: false,
              data: action.payload.body,
              errorCode: '',
              errorMessage: '',
            },
          };
    
        case actionConstants.KYC_FORM_RESUBMIT_FAILURE:
          return {
            ...state,
            kycReSubmitState: {
              ...state.kycReSubmitState,
              isLoading: false,
              isSuccess: false,
              isFailure: true,
              data: {},
              errorCode: action.payload,
              errorMessage: action.payload.body,
            },
          };

          case actionConstants.TOGGLE_ENV_REQUEST:
            return {
              ...state,
              toggleEnvState: {
                ...state.toggleEnvState,
                isLoading: true,
                isSuccess: false,
                isFailure: false,
                data: {},
                errorCode: '',
                errorMessage: '',
              },
            };
          case actionConstants.TOGGLE_ENV_SUCCESS:
            return {
              ...state,
              toggleEnvState: {
                ...state.toggleEnvState,
                isLoading: false,
                isSuccess: true,
                isFailure: false,
                data: action.payload.body,
                errorCode: '',
                errorMessage: '',
              },
            };
      
          case actionConstants.TOGGLE_ENV_FAILURE:
            return {
              ...state,
              toggleEnvState: {
                ...state.toggleEnvState,
                isLoading: false,
                isSuccess: false,
                isFailure: true,
                data: {},
                errorCode: action.payload,
                errorMessage: action.payload.body,
              },
            };
            case actionConstants.TOGGLE_ENV_CLEAR:
              return {
                ...state,
                toggleEnvState
              };

    default:
      return state;
  }
}
